export type CreateComponentRequest = {
  godFlg: string;
  dipByRgn: string;
  cpntId: string;
  cpntName: string;
  cpntDesc: string;
  rootCpntId: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
};
type EdhPrtcl = {
  inOutTypeCd?: string;
  edhPrtclTypeCd?: string;
};
type IfStrtMthd = {
  ifStrtMthdTypeCd?: string;
};
type EdhNtfctnType = {
  inOutTypeCd?: string;
  edhNtfctnTypeCd?: string;
};
